<template>
    <section class="home-container">
        <MasterPage title="处方管理">
            <div slot="title-icon">
                <Icon type="md-analytics" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="患者账号：">
                            <Select v-model="select.userId" clearable placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="营养目标：">
                            <Select v-model="select.nutritionalGoalId" clearable placeholder="请选择">
                                <Option v-for="item in nutritionalGoalAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="时间段：">
                            <DatePicker v-model="select.dataTime" type="datetimerange" placeholder="请选择时间段" style="width: 100%"></DatePicker>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="处方状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>

            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增处方" fullscreen footer-hide @on-cancel="cancelItem">
            <div style="display: flex;flex-direction: column;height: 100%">
                <Steps :current="tabs">
                    <Step title="患者账号" content="选择患者账号并绑定处方"></Step>
                    <Step title="营养目标" content="为患者制定每日营养目标"></Step>
                    <Step title="饮食原则" content="给患者选定饮食原则"></Step>
                    <Step title="饮食食谱" content="为患者制定每周饮食食谱"></Step>
                    <Step title="药品营养素" content="药品及营养素服用指导"></Step>
                    <Step title="医嘱说明" content="用药指示与医学指令"></Step>
                </Steps>
                <Carousel v-model="tabs" arrow="never" dots="none" style="flex: 1;padding-top: 50px;" v-if="addModel">
                    <CarouselItem >
                        <Row type="flex" justify="center">
                            <Col style="width: 600px">
                            <Form :label-width="100">
                                <FormItem label="患者账号：">
                                    <Select @on-change="userSelect" v-model="itemAdd.userId" placeholder="请选择">
                                        <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Form>
                            <div style="padding:50px 20px;">
                                <Card>
                                    <p slot="title">患者信息</p>
                                    <p>
                                    <Form :label-width="100">
                                        <FormItem label="患者编号：" class="myBorder">{{userInfo.id}}</FormItem>
                                        <Row>
                                            <Col span="12">
                                            <FormItem label="患者名称：" class="myBorder">{{userInfo.name}}</FormItem>
                                            </Col>
                                            <Col span="12">
                                            <FormItem label="患者性别：" class="myBorder">
                                                <span v-show="itemAdd.userId!=''">{{userInfo.sex==0?'男':userInfo.sex==1?'女':'-'}}</span>
                                            </FormItem>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span="12">
                                            <FormItem label="患者账号：" class="myBorder">{{userInfo.phone}}</FormItem>
                                            </Col>
                                            <Col span="12">
                                            <FormItem label="患者密码：" class="myBorder">
                                                <span v-show="itemAdd.userId!=''">**********</span>
                                            </FormItem>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span="12">
                                            <FormItem label="患者生日：" class="myBorder">{{userInfo.birthday | dateTimeToString}}</FormItem>
                                            </Col>
                                            <Col span="12">
                                            <FormItem label="账号状态：" class="myBorder">
                                                <span v-show="itemAdd.userId!=''">{{userInfo.isLock?"已禁用":"在使用"}}</span>
                                            </FormItem>
                                            </Col>
                                        </Row>
                                        <FormItem label="患者创建时间：" class="myBorder">{{userInfo.createTime | dateTimeToString}}</FormItem>
                                    </Form>
                                    </p>
                                </Card>
                            </div>
                            <Row v-show="itemAdd.userId!=''" style="padding: 10px 0px">
                                <Col span="8" offset="8">
                                    <Button type="info" long @click="nextSteps">下一步</Button>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row type="flex" justify="center">
                            <Col style="width: 600px">
                            <Form :label-width="100">
                                <FormItem label="营养目标：">
                                    <Select @on-change="nutritionalGoalSelect" v-model="itemAdd.nutritionalGoalId" placeholder="请选择">
                                        <Option v-for="item in nutritionalGoalAllList" :value="item.id" :key="item.id">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Form>
                            <div v-show="itemAdd.nutritionalGoalId!=''" style="padding:50px 20px;">
                                <Card>
                                    <p slot="title">营养目标</p>
                                    <p>
                                    <Table stripe max-height="250" :columns="columnsNutritionalGoalInfo" :data="nutritionalGoalInfo.nutritionalGoalInfos"></Table>
                                    </p>
                                </Card>
                            </div>
                            <Row style="padding: 10px 0px">
                                <Col span="8" offset="3">
                                <Button type="warning" long @click="prevSteps">上一步</Button>
                                </Col>
                                <Col v-show="itemAdd.nutritionalGoalId!=''" span="8" offset="2">
                                <Button type="info" long @click="nextSteps">下一步</Button>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem >
                        <Row type="flex" justify="center">
                            <Col style="width: 600px">
                            <Form :label-width="100">
                                <FormItem label="饮食原则：">
                                    <Select multiple  v-model="dietGuidelinesId" placeholder="请选择">
                                        <Option v-for="item in dietGuidelinesAllList" :value="item.id" :key="item.id">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Form>
                            <Collapse accordion v-if="dietGuidelinesId.length > 0 ">
                                <Panel v-if="dietGuidelinesId.indexOf(item.id) !== -1" v-for="item in dietGuidelinesAllList" :key="item.id">
                                    {{item.name}}
                                    <p slot="content">
                                    <Table stripe max-height="350" :columns="columnsDietGuideline" :data="item.foodMaterialVOs"></Table>
                                    </p>
                                </Panel>
                            </Collapse>
                            <Row style="padding: 10px 0px">
                                <Col span="8" offset="3">
                                <Button type="warning" long @click="prevSteps">上一步</Button>
                                </Col>
                                <Col v-if="dietGuidelinesId.length > 0" span="8" offset="2">
                                <Button type="info" long @click="nextSteps">下一步</Button>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row type="flex" justify="center">
                            <Col style="width: 1000px">
                            <Form :label-width="100">
                                <Form :label-width="100">
                                    <FormItem label="食谱模板：">
                                        <Select @on-change="dietPlanSelect" clearable v-model="itemAdd.dietPlanId" placeholder="请选择">
                                            <Option v-for="item in dietPlanAllList" :value="item.id" :key="item.id">
                                                {{ item.name }}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                </Form>
                            </Form>
                            <div v-show="itemAdd.dietPlanId!=''" style="padding-bottom: 20px;">
                                <Card>
                                    <p slot="title">食谱模板</p>
                                    <p>
                                    <Table max-height="500" border stripe :columns="columnsAdd" :data="dietPlanitemAdd">
                                        <template v-for="week in weekList" slot-scope="{ row, index }" :slot="week">
                                            <Form style="margin: 10px 0">
                                                <Row v-if="templateInfo.type==row[week]" v-for="(templateInfo,indes) in addItemInfo.infoList" :key="templateInfo.key">
                                                    <Col span="12">
                                                    <FormItem style="margin: 10px 5px">
                                                        <Select @on-change="changeSelect($event,templateInfo)"
                                                                :transfer="true" filterable v-model="templateInfo.foodMaterialId" placeholder="请选择食材">
                                                            <Option v-for="item in foodMaterialAllList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                                        </Select>
                                                    </FormItem>
                                                    </Col>
                                                    <Col span="6">
                                                    <FormItem style="margin: 10px 5px">
                                                        <InputNumber :min="0" v-model="templateInfo.value"
                                                                     :formatter="value => `${value}${templateInfo.unit}`"
                                                                     :parser="value => value.replace(templateInfo.unit, '')"
                                                                     placeholder="请输入食材数量"></InputNumber>
                                                    </FormItem>
                                                    </Col>
                                                    <Col span="2">
                                                    <Tooltip :transfer="true" placement="top" content="备注" theme="light">
                                                        <Poptip :transfer="true" placement="right">
                                                            <Button class="my_Button" style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">
                                                                <Icon type="md-git-network" size="20" />
                                                            </Button>
                                                            <div class="api" slot="content">
                                                                <Input type="text" v-model="templateInfo.remark" placeholder="请输入备注" />
                                                            </div>
                                                        </Poptip>
                                                    </Tooltip>
                                                    </Col>
                                                    <Col span="4">
                                                    <FormItem style="margin: 10px 5px">
                                                        <Button @click="removeTemplateInfo(indes)">删除</Button>
                                                    </FormItem>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <FormItem style="margin: 10px 5px">
                                                        <Button type="dashed" long @click="addTemplateInfo(row[week])" icon="md-add">添加新的食物</Button>
                                                    </FormItem>
                                                </Row>
                                            </Form>
                                        </template>
                                    </Table>
                                    <Form :label-width="60">
                                        <Row style="padding: 20px 0 0">
                                            <Col span="7" offset="4">
                                            <FormItem label="开始时间" style="margin:0">
                                                <DatePicker v-model="addItemInfo.startTime" type="datetime" placeholder="请选择问卷开始时间" ></DatePicker>
                                            </FormItem>
                                            </Col>
                                            <Col span="7" offset="2">
                                            <FormItem label="结束时间" style="margin:0">
                                                <DatePicker v-model="addItemInfo.endTime" type="datetime" placeholder="请选择问卷结束时间" ></DatePicker>
                                            </FormItem>
                                            </Col>
                                        </Row>
                                    </Form>
                                    </p>
                                </Card>
                            </div>
                            <div class="myText">
                                推荐新增处方时为患者添加食谱
                            </div>
                            <Row style="padding: 10px 0px">
                                <Col span="8" offset="3">
                                <Button type="warning" long @click="prevSteps">上一步</Button>
                                </Col>
                                <Col span="8" offset="2">
                                <Button type="info" long @click="nextSteps">下一步</Button>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Layout>
                            <Sider hide-trigger width="400">
                                <Tabs type="card">
                                    <TabPane label="药品">
                                        <div style="padding:0 16px 0 16px">
                                            <Card style="margin-bottom: 16px">
                                                <p slot="title">处方药品</p>
                                                <p>
                                                <!--<Input style="padding-bottom: 10px" search enter-button-->
                                                       <!--placeholder="处方药品名称。。。" @on-search="medicineSearch(true)"  />-->
                                                <Table  height="200" stripe :columns="columnsMedicine" :data="medicineAllList.OTCList"></Table >
                                                </p>
                                            </Card>
                                            <Card style="margin-bottom: 16px">
                                                <p slot="title">非处方药品</p>
                                                <p>
                                                 <!--<Input style="padding-bottom: 10px" search enter-button-->
                                                        <!--placeholder="非处方药品。。。" @on-search="medicineSearch(false)"  />-->
                                                <Table height="200" stripe :columns="columnsMedicine" :data="medicineAllList.notOTCList"></Table>
                                                </p>
                                            </Card>
                                        </div>
                                    </TabPane>
                                    <TabPane label="营养素">
                                        <div style="padding:0 16px 0 16px">
                                            <Card style="margin-bottom: 16px">
                                                <p slot="title">处方营养素</p>
                                                <p>
                                                <!--<Input style="padding-bottom: 10px" search enter-button-->
                                                           <!--placeholder="处方营养素名称。。。" @on-search="medicineSearch"  />-->
                                                <Table  height="200" stripe :columns="columnsMedicine" :data="nutrientAllList.OTCList"></Table >

                                                </p>
                                            </Card>
                                            <Card style="margin-bottom: 16px">
                                                <p slot="title">非处方营养素</p>
                                                <p>
                                                <!--<Input style="padding-bottom: 10px" search enter-button-->
                                                       <!--placeholder="非处方营养素名称。。。" @on-search="medicineSearch"  />-->
                                                <Table height="200" stripe :columns="columnsMedicine" :data="nutrientAllList.notOTCList"></Table>
                                                </p>
                                            </Card>
                                        </div>
                                    </TabPane>
                                </Tabs>
                            </Sider>
                            <Layout>
                                <Content>
                                    <div style="padding: 50px 20px">
                                    <Input v-model="itemAdd.content" type="textarea"
                                           :autosize="{minRows:30,maxRows: 30}"placeholder="请输入药品及营养素服用指导。。。" />
                                    </div>
                                </Content>
                            </Layout>
                        </Layout>
                        <Row type="flex" justify="center">
                            <Col style="width: 600px">
                            <Row style="padding: 10px 0px" >
                                <Col span="8" offset="3">
                                <Button type="warning" long @click="prevSteps">上一步</Button>
                                </Col>
                                <Col v-show="itemAdd.content.length > 0" span="8" offset="2">
                                <Button type="info" long @click="nextSteps">下一步</Button>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row type="flex" justify="center">
                            <Col style="width: 600px">
                            <Form label-position="top">
                                <FormItem label="医嘱说明：">
                                    <Input v-model="doctorAdvice" type="textarea" :autosize="{minRows:20,maxRows: 20}"placeholder="请输入用药指示与医学指令。。。" />
                                </FormItem>
                            </Form>
                            <Row style="padding: 10px 0px">
                                <Col span="8" offset="3">
                                <Button type="warning" long @click="prevSteps">上一步</Button>
                                </Col>
                                <Col v-show="doctorAdvice.length > 0" span="8" offset="2">
                                <Button type="success" long @click="addItem_model">确认</Button>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                    </CarouselItem>
                </Carousel>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改处方" width="900" @on-cancel="cancelItem">
            <Form :label-width="90">
                <Row>
                    <Col span="12">
                    <FormItem label="处方姓名：">
                        <Input v-model="updateInfoItem.name" placeholder="请输入" />
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="处方职称：">
                        <Input v-model="updateInfoItem.title" placeholder="请输入" />
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="处方专长：">
                        <Input v-model="updateInfoItem.profession" placeholder="请输入" />
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="处方详情" footer-hide fullscreen width="750">
            <div style="padding: 40px;background-color: #f5f5f5">
                <Card style="margin-bottom: 40px">
                    <p slot="title">患者信息</p>
                    <p>
                    <Form :label-width="100">
                        <FormItem label="患者编号：" class="myBorder">{{infoItemUserInfo.id}}</FormItem>
                        <Row>
                            <Col span="12">
                            <FormItem label="患者名称：" class="myBorder">{{infoItemUserInfo.name}}</FormItem>
                            </Col>
                            <Col span="12">
                            <FormItem label="患者性别：" class="myBorder">
                                <span v-show="infoItemUserInfo.id!=''">{{infoItemUserInfo.sex==0?'男':infoItemUserInfo.sex==1?'女':'-'}}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="12">
                            <FormItem label="患者账号：" class="myBorder">{{infoItemUserInfo.phone}}</FormItem>
                            </Col>
                            <Col span="12">
                            <FormItem label="患者密码：" class="myBorder">
                                <span v-show="infoItemUserInfo.id!=''">**********</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="12">
                            <FormItem label="患者生日：" class="myBorder">{{infoItemUserInfo.birthday | dateTimeToString}}</FormItem>
                            </Col>
                            <Col span="12">
                            <FormItem label="账号状态：" class="myBorder">
                                <span v-show="infoItemUserInfo.id!=''">{{infoItemUserInfo.isLock?"已禁用":"在使用"}}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="患者创建时间：" class="myBorder">{{infoItemUserInfo.createTime | dateTimeToString}}</FormItem>
                    </Form>
                    </p>
                </Card>
                <Card style="margin-bottom: 40px">
                    <p slot="title">营养目标</p>
                    <p>
                    <Table stripe max-height="250" :columns="columnsNutritionalGoalInfo" :data="infoItemNutritionalGoalInfo.nutritionalGoalInfos"></Table>
                    </p>
                </Card>
                <Card style="margin-bottom: 40px">
                    <p slot="title">饮食原则</p>
                    <p>
                    <Collapse value="0" accordion>
                        <Panel :name="index.toString()" v-for="(item,index) in infoItemDietGuidelinesInfo" :key="item.id">
                            {{item.name}}
                        <p slot="content">
                        <Table stripe max-height="350" :columns="columnsDietGuidelinesInfo" :data="item.foodMaterialVOs"></Table>
                        </p>
                        </Panel>
                    </Collapse>
                    </p>
                </Card>
                <Card style="margin-bottom: 40px">
                    <p slot="title">饮食食谱</p>
                    <p>
                    <Table border stripe :columns="columnsIndo" :data="itemIndo"></Table>
                    </p>
                </Card>
                <Card style="margin-bottom: 40px">
                    <p slot="title">药品营养素说明</p>
                    <p v-html="infoItem.content">
                    </p>
                </Card>
                <Card>
                    <p slot="title">医嘱说明</p>
                    <p v-html="infoItemDoctorAdviceInfo.content">
                    </p>
                </Card>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage,
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '患者',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let user = {}
                            this.userAllList.forEach((item) => {
                                if(item.id === this.dataList[params.index].userId){
                                    user = item
                                    return
                                }
                            })
                            return h("span",user.name)
                        }
                    },
                    {
                        title: '营养目标',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let nutritionalGoal = {}
                            this.nutritionalGoalAllList.forEach((item) => {
                                if(item.id === this.dataList[params.index].nutritionalGoalId){
                                    nutritionalGoal = item
                                    return
                                }
                            })
                            return h("span",nutritionalGoal.name)
                        }
                    },
                    {
                        title: '关联食谱',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].dietPlanId == null || this.dataList[params.index].dietPlanId == ""){
                                return h('span', '未关联')
                            }else{
                                return h('span', '已关联')
                            }
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                // Buttons.push(
                                //     h('Button', {
                                //         props: {
                                //             type: 'primary',
                                //             icon:'md-create',
                                //             label:"small",
                                //         },
                                //         style: {
                                //             marginRight: '5px'
                                //         },
                                //         on: {
                                //             click: () => {
                                //                 this.updateItem_modal(this.dataList[params.index])
                                //             }
                                //         }
                                //     }, '编辑')
                                // )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                collapseList:['1','2'],
                userAllList:[],
                userInfo:{},
                dietPlanAllList:[],
                dietPlanInfo:{},
                nutritionalGoalAllList:[],
                nutritionalGoalInfo:{nutritionalGoalInfos:[]},
                columnsNutritionalGoalInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            let item = params.row
                            return h("span",item.nutritionType.name + '（' + item.nutritionType.forShort + '）- ' +  item.nutritionType.englishName )
                        },
                    },
                    {
                        title: '含量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            let item = params.row
                            return h("span",item.value + ' ' + item.nutritionType.unit )
                        },
                    },
                ],//药物营养素表头
                dietGuidelinesAllList:[],//所有原则
                dietGuidelinesId:[],//选中的原则
                foodMaterialAllList:[],//食材
                columnsAdd:[
                    {
                        title: '时间',
                        width: 100,
                        key:'dataTime',
                        align: 'center',
                        fixed: 'left',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'sev',
                        width: 450,
                    },
                    {
                        title: '周一',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'one',
                        width: 450,
                    },
                    {
                        title: '周二',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'tow',
                        width: 450,
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'thr',
                        width: 450,
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'fou',
                        width: 450,
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'fiv',
                        width: 450,
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot:'six',
                        width: 450,
                    },
                ],//食谱表头
                dietPlanitemAdd:[{dataTime:'早餐',one:'01',tow:'11',thr:'21',fou:'31',fiv:'41',six:'51',sev:'61'},
                    {dataTime:'午餐',one:'02',tow:'12',thr:'22',fou:'32',fiv:'42',six:'52',sev:'62'},
                    {dataTime:'晚餐',one:'03',tow:'13',thr:'23',fou:'33',fiv:'43',six:'53',sev:'63'},
                    {dataTime:'加餐',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'}],
                weekList:['sev','one','tow','thr','fou','fiv','six'],
                dietPlanId_falg:false,
                medicineAllList:[],//药品
                columnsDietGuideline:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '食材',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            return h('span',params.row.name+"("+ params.row.unit+")")
                        }
                    },
                    {
                        title: '原则',
                        key: 'dietText',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '备注',
                        key: 'dietTextRemark',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    }
                ],
                columnsMedicine:[
                    {
                        type: 'index',
                        width: 40,
                        align: 'center',
                    },
                    {
                        title: '名称',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        filter: {
                            type: 'Input'
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        render: (h,params) => {
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    icon:'md-add',
                                    label:"small",
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.addContextTo(params.row)
                                    }
                                }
                            }, '添加')
                        }
                    },
                ],
                nutrientAllList:[],//营养素素
                addItemInfo:{
                    startTime:'',
                    endTime:'',
                    infoList:[],
                },//食谱内容
                doctorAdvice:'',//医嘱
                select:{
                    userId:'',
                    dietPlanId:'',
                    nutritionalGoalId:'',
                    dataTime:[],
                    isDeleted:'false',
                },//搜索
                tabs:0,
                itemAdd:{
                    userId:'',
                    dietPlanId:'',
                    nutritionalGoalId:'',
                    content:"",
                },
                updateInfoItem:"",
                infoItem:{},
                infoItemUserInfo: {},
                infoItemNutritionalGoalInfo: {},
                infoItemDietPlanInfo: {infoVOList:[]},
                infoItemDoctorAdviceInfo:{},
                infoItemDietGuidelinesInfo: [],
                itemIndo:[{dataTime:'早餐',sev:'01',one:'11',tow:'21',thr:'31',fou:'41',fiv:'51',six:'61'},
                    {dataTime:'午餐',sev:'02',one:'12',tow:'22',thr:'32',fou:'42',fiv:'52',six:'62'},
                    {dataTime:'晚餐',sev:'03',one:'13',tow:'23',thr:'33',fou:'43',fiv:'53',six:'63'},
                    {dataTime:'加餐',sev:'04',one:'14',tow:'24',thr:'34',fou:'44',fiv:'54',six:'64',}],
                columnsIndo:[
                    {
                        title: '时间',
                        width: 60,
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let week=['早','午','晚','加']
                            return h("span",week[params.index] + "餐")
                        }
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 6 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周一',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 0 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周二',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 1 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 2 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 3 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 4 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render:(h,params)=>{
                            let code = 5 + "" + (params.index+1)
                            let hList = []
                            if (this.infoItemDietPlanInfo != undefined) {
                                this.infoItemDietPlanInfo.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                            }
                            return h("div",hList)
                        }
                    },
                ],
                columnsDietGuidelinesInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '食材',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            return h('span',params.row.name+"("+ params.row.unit+")")
                        }
                    },
                    {
                        title: '原则',
                        key: 'dietText',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '备注',
                        key: 'dietTextRemark',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    }
                ],
                key:0,
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
            this.findAllDietPlan()
            this.findAllNutritionalGoalList()
            this.findALLMedicineList()
            this.findALLNutrientList()
            this.findAllDietGuidelinesList()
            this.findAllFoodMaterial()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllFoodMaterial(){
                this.$http.post('foodMaterial/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'食材查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            findAllDietPlan(){
                this.$http.post('dietPlan/listTemplate',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietPlanAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'饮食计划列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllNutritionalGoalList(){
                this.$http.post('nutritionalGoal/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.nutritionalGoalAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'营养目标列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findALLMedicineList(){
                this.$http.post('medicine/list2').then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.medicineAllList = msg.data
                    }else {
                        this.$Notice.error({title:'药品列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findALLNutrientList(){
                this.$http.post('nutrient/list2').then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.nutrientAllList = msg.data
                    }else {
                        this.$Notice.error({title:'药品列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllDietGuidelinesList(){
                this.$http.post('dietGuidelines/list',{
                    isDeleted:false,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietGuidelinesAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'饮食原则查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('prescription/list',{
                    userId:this.select.userId == undefined ? "": this.select.userId,
                    nutritionalGoalId:this.select.nutritionalGoalId == undefined ? "": this.select.nutritionalGoalId,
                    startTime:this.select.dataTime[0] == undefined || this.select.dataTime[0] == "" ? new Date(undefined):this.select.dataTime[0]+"",
                    endTime:this.select.dataTime[1] == undefined || this.select.dataTime[1] == "" ? new Date(undefined):this.select.dataTime[1]+"",
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'处方列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            prevSteps(){
                if (this.tabs > 0){
                    this.tabs--
                }
            },
            nextSteps(){
                if (this.tabs < 5){
                    this.tabs++
                }
            },
            userSelect(value){
                this.userAllList.forEach((item) => {
                    if(item.id === value){
                        this.userInfo = item
                        return
                    }
                })
            },
            nutritionalGoalSelect(value){
                this.nutritionalGoalAllList.forEach((item) => {
                    if(item.id === value){
                        this.nutritionalGoalInfo = item
                        return
                    }
                })
            },
            dietPlanSelect(value){
                if (value == undefined){
                    return this.addItemInfo.infoList.length = 0
                }
                let obj = {}
                this.dietPlanAllList.forEach((item) => {
                    if(item.id === value){
                        obj = item
                        return
                    }
                })
                let infoList = []
                obj.infoVOList.map((item)=>{
                    item.infoList.forEach((info)=> {
                        info['key'] = this.key++
                        info['unit'] = info.foodMaterial.unit
                        infoList.push(JSON.parse(JSON.stringify(info)))
                    })
                })
                // let aaa = [{type:0,nutritional:[]},{type:1,nutritional:[]},{type:2,nutritional:[]},
                //     {type:3,nutritional:[]},{type:4,nutritional:[]},{type:5,nutritional:[]},{type:6,nutritional:[]}]
                // obj.infoVOList.map((item)=>{
                //     item.infoList.forEach((info)=> {
                //         infoList.push({foodMaterialId:info.foodMaterialId,type:info.type,value:info.value,unit:info.foodMaterial.unit,remark:info.remark,key:this.key++})
                //         if (this.nutritionalGoalInfo.nutritionalGoalInfos.length > 0 && info.foodMaterial.nutritionTypeList.length > 0){
                //             for (let i = 0 ; i < this.nutritionalGoalInfo.nutritionalGoalInfos.length ; i++){
                //                 for (let j = 0 ; j < info.foodMaterial.nutritionTypeList.length ; j++){
                //                     let nutritionalGoalInfo = this.nutritionalGoalInfo.nutritionalGoalInfos[i]
                //                     let dietPlanNutritionType = info.foodMaterial.nutritionTypeList[j]
                //                     if (nutritionalGoalInfo.id == dietPlanNutritionType.id) {
                //                         for (let m = 0 ; m < aaa.length ; m++) {
                //                             if (info.type.substr(0,1) == aaa[m].type){
                //                                 aaa[m].nutritional
                //                                 break
                //                             }
                //                         }
                //                         // if (aaa[nutritionalGoalInfo.id] == undefined){
                //                         //     aaa[nutritionalGoalInfo.id] = parseInt(dietPlanNutritionType.value) * parseInt(info.value) /100
                //                         // } else {
                //                         //     aaa[nutritionalGoalInfo.id] += parseInt(dietPlanNutritionType.value) * parseInt(info.value) /100
                //                         // }
                //                         break
                //                     }
                //                 }
                //             }
                //         }
                //     })
                // })
                this.addItemInfo.infoList = infoList
            },
            changeSelect(value,templateInfo){
                for (let i = 0 ; i < this.foodMaterialAllList.length ; i++){
                    let obj = this.foodMaterialAllList[i]
                    if (obj.id == value) {
                        templateInfo.unit = obj.unit == ''? "" : obj.unit
                        return
                    }
                }
            },
            addTemplateInfo(week){
                this.addItemInfo.infoList.push({foodMaterialId:'',value:0,type:week,remark:'',unit:'',key:this.key++})
            },
            removeTemplateInfo(index){
                this.addItemInfo.infoList.splice(index, 1)
            },
            medicineSearch(type){
                console.log(search)
            },
            addItem_model(){
                this.$Modal.confirm({
                    title: '确认为患者“'+ this.userInfo.name + '”新增处方',
                    loading:true,
                    onOk: () => {
                        this.addItem_data();
                    }
                });
            },
            addItem_data(){
                if (this.itemAdd.userId.length <= 0){
                    this.tabs = 0
                    return this.$Message.warning('请选择患者账号');
                }
                if (this.itemAdd.nutritionalGoalId.length <= 0){
                    this.tabs = 1
                    return this.$Message.warning('请选择营养目标');
                }
                if (this.dietGuidelinesId.length <= 0){
                    this.tabs = 2
                    return this.$Message.warning('请选择饮食原则');
                }
                if (this.itemAdd.dietPlanId != undefined && this.itemAdd.dietPlanId != ""){
                    this.dietPlanId_falg = true
                    if (this.addItemInfo.startTime == undefined || this.addItemInfo.startTime.length <= 0){
                        this.tabs = 3
                        return this.$Message.warning('请选择食谱开始时间');
                    }
                    if (this.addItemInfo.endTime == undefined || this.addItemInfo.endTime.length <= 0){
                        this.tabs = 3
                        return this.$Message.warning('请选择食谱结束时间');
                    }
                    let flag = false
                    this.addItemInfo.infoList.forEach(function (TemplateInfo) {
                        if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0){
                            flag = true
                            return
                        }
                    })
                    if (flag || this.addItemInfo.infoList.length<=0) {
                        this.tabs = 3
                        return this.$Message.warning('请填写食谱完整数据');
                    }
                }
                if (this.itemAdd.content.length <= 0){
                    this.tabs = 4
                    return this.$Message.warning('请输入药品、营养素说明');
                }
                if (this.doctorAdvice.length <= 0){
                    this.tabs = 5
                    return this.$Message.warning('请输入医嘱说明');
                }
                this.addItem_insertUserDietGuideLine()
            },
            addItem_insertUserDietGuideLine(){
                this.$http.post('prescription/insertUserDietGuideLine',{
                    userId:this.userInfo.id,
                    list:this.dietGuidelinesId.join(",")
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '原则关联成功'});
                        if (this.dietPlanId_falg){
                            this.addItem_dietPlan()
                        } else{
                            this.addItem()
                        }
                    }else {
                        this.$Notice.error({title:'原则关联失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            addItem_dietPlan(){
                this.$http.post('dietPlan/add',{
                    userId:this.userInfo.id,
                    startTime:this.addItemInfo.startTime == undefined || this.addItemInfo.startTime == "" ? new Date(undefined):this.addItemInfo.startTime+"",
                    endTime:this.addItemInfo.endTime == undefined || this.addItemInfo.endTime == "" ? new Date(undefined):this.addItemInfo.endTime+"",
                    infoList:JSON.stringify(this.addItemInfo.infoList)
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱新增成功'});
                        this.itemAdd.dietPlanId = msg.data.id
                        this.addItem()
                    }else {
                        this.$Notice.error({title:'食谱新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            // find(){
            //     let text = "";
            //     if (window.getSelection) {
            //         text = window.getSelection().toString();
            //     } else if (document.selection && document.selection.type != "Control") {
            //         text = document.selection.createRange().text;
            //     }
            //     console.log('value:' + text);
            // },
            addItem(){
                this.$http.post('prescription/add',
                    this.itemAdd,
                {emulateJSON:false}).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '处方新增成功'});
                        this.addItem_doctorAdvice()
                    }else {
                        this.$Notice.error({title:'处方新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            addItem_doctorAdvice(){
                this.$http.post('doctorAdvice/add',{
                        userId:this.userInfo.id,
                        content:this.doctorAdvice},
                    {emulateJSON:false}).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医嘱新增成功'});
                        this.cancelItem()
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医嘱新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入处方姓名');
                }
                if (this.updateInfoItem.title.length <= 0){
                    return this.$Message.warning('请输入处方职称');
                }
                if (this.updateInfoItem.profession.length <= 0){
                    return this.$Message.warning('请输入处方专长');
                }
                this.updateLoading = true
                this.$http.post('doctor/update',
                    this.updateInfoItem,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '处方修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'处方修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
            },
            async infoItem_modal(item){
                this.infoItem = item
                // 查询处方食谱
                if (item.dietPlanId != undefined && item.dietPlanId != null && item.dietPlanId != ''){
                    this.findDiletPlanById(item.dietPlanId)
                }
                // 查询处方饮食原则
                this.findDietGuidelinesById(item.userId)
                // 查询处方医嘱
                this.findDoctorAdviceById(item.userId)
                // 查询处方营养标准
                for (let i = 0 ; i < this.nutritionalGoalAllList.length ; i++){
                    let item = this.nutritionalGoalAllList[i]
                    if(item.id == this.infoItem.nutritionalGoalId){
                        this.infoItemNutritionalGoalInfo= item
                        break
                    }
                }
                // 查询处方用户信息
                for (let i = 0 ; i < this.userAllList.length ; i++){
                    let item = this.userAllList[i]
                    if(item.id == this.infoItem.userId){
                        this.infoItemUserInfo = item
                        break
                    }
                }

                this.infoModel = true
            },
            findDiletPlanById(id){
                this.$http.post('dietPlan/list',{
                    id:id,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.infoItemDietPlanInfo = msg.data.list[0]
                    }else {
                        this.$Notice.error({title:'食谱查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findDietGuidelinesById(id){
                this.$http.post('user/getDietLinesByUser',{
                    userId:id,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.infoItemDietGuidelinesInfo = msg.data
                    }else {
                        this.$Notice.error({title:'饮食原则查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findDoctorAdviceById(id){
                this.$http.post('doctorAdvice/list',{
                    userId:id,
                    isDeleted:false,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.infoItemDoctorAdviceInfo = msg.data.list[0]
                    }else {
                        this.$Notice.error({title:'医嘱查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用处方“”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('prescription/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '处方启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'处方启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用处方“”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('prescription/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '处方禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'处方禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            routerPush(url){
                this.cancelItem()
                this.$router.push(url)
            },
            addContextTo (item) {
                this.itemAdd.content += ' 描述：' + item.description + ' 英文描述：' + item.descriptionEn
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }

    .ivu-layout-sider{
        background-color: #FAFAFA;
    }

    .ivu-layout{
        background-color: #F3F5F6;
    }

    .myBorder{
        border-bottom: 1px solid #e8e8e8;
        margin-left: 5px;
        margin-right: 5px;
    }

    .myText{
        text-align: center;
        line-height: 30px;
        color: #8E8E8E;
    }

</style>


